import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const Hackathon2026 = () => {
    const images = [
        "1000459298.jpg" ,
        "1000460211.jpg" ,
        "1000460442.jpg" ,
        "1000460839.jpg" ,
        "1000460843.jpg" ,
        "1000460847.jpg" ,
        "1000460849.jpg" ,
        "1000460887.jpg" ,
        "1000460892.jpg" ,
        "1000460894.jpg" ,
        "1000460896.jpg" ,
        "1000460898.jpg" ,
        "1000460900.jpg" ,
        "1000460902.jpg" ,
        "1000460904.jpg" ,
        "1000460906.jpg" ,
        "1000463981.jpg" ,
        "1000463989.jpg",
    ];

    const baseUrl = "https://admin.swec.ac.in/assetsswec/img/hackathon-2026/";

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">

                                <h2>Hackathon 2026</h2>

                                <div className="spotlight-group">
                                    <div className="row">
                                        {images.map((img, index) => (
                                            <div key={index} className="col-md-6 mb-3">
                                                <a
                                                    className="spotlight"
                                                    href={`${baseUrl}${img}`}
                                                >
                                                    <img
                                                        src={`${baseUrl}${img}`}
                                                        alt={`Hackathon 2026 Image ${index + 1}`}
                                                        className="img-responsive sixteen-nine"
                                                    />
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Hackathon2026;